<template>
  <div>
    <div :id="`flex_${timestamp}_${index}`"></div>
  </div>
</template>

<script>
import { flex2html } from '@/assets/js/flex2html.min.js'
import moment from 'moment'
export default {
  props: ['value', 'index'],
  data: () => ({
    timestamp: moment().format('x')
  }),
  mounted() {
    if (this.value) {
      let data = this.value
      try {
        if (typeof data.contents == 'string') {
          data.contents = JSON.parse(data.contents)
        }
      } catch (error) {
        console.error(error)
      }
      flex2html(`flex_${this.timestamp}_${this.index}`, data)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/LineFlexPreview.vue